import { getSheetUpdate } from '@/requests/ac';
import { formalDateFormat } from '@/functions/general.js';

export default {
  data() {
    return {
      /* sheet_update_key:'metrics', */
    };
  },
  computed: {
    sheet_update(){return this.$store.getters[`sheet_update_${this.sheet_update_key}`]},
  },
  methods: {
    formalDateFormat(date){
      return date ? formalDateFormat(new Date(date)): '';
    },
    async reGetSheetUpdate(){
      if(!await this.assignAccess()) return;
      getSheetUpdate(this.sheet_update_key)
        .then(r => r && r.updated_at && this.$store.dispatch('set', {key: `sheet_update_${this.sheet_update_key}`, val: r.updated_at}));
    },

  },
};
